import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const useOnboardingRedirect = (userOnboardingData) => {
    const navigate = useNavigate();

    useEffect(() => {
        if (!userOnboardingData?.is_onboarding) {
            navigate('/');
        }
    }, [userOnboardingData, navigate]);
};

export default useOnboardingRedirect;
